import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import * as Icon from "react-bootstrap-icons";


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function SimpleSelect({people,selected,setSelected,sData,disableCalendar,setInput,inputShow}) {

  return (
    <>
    
   {inputShow ? 
    <div className='bg-white flex'>
<input
              autoComplete="off"
              type="text"
              name="name"
              id="firstname"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
              onChange={(e)=>{setSelected(e.target.value)}}
            />
            <Icon.X className='my-auto text-xl'
                          onClick={(e) => {
                            setSelected(people[0]);
                            setInput(false)
                          }}
                        />
    </div> :<Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <>
          {/* <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Assigned to</Listbox.Label> */}
          <div className="relative">
            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white pr-10 text-left text-gray-900 focus:outline-none focus:ring-2 focus:ring-white sm:text-sm sm:leading-6">
              <span className="block truncate">{selected}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-[12rem] w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {people?.map((person) => (
                  <>
                  
                  <Listbox.Option
                  // disabled={person?.id === sData?.id || (person?.id == 2 && disableCalendar)}
                    key={person}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                        'relative cursor-default select-none py-2 pl-3 pr-9'
                      )
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                          {person}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-[var(--brand-primary)]',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                  </>
                ))}
                  <Listbox.Option
                  // disabled={person?.id === sData?.id || (person?.id == 2 && disableCalendar)}
                  onClick={()=>setInput(true)}
                    key="others"
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                        'relative cursor-default select-none py-2 pl-3 pr-9'
                      )
                    }
                    value="Others"
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                          Others
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-[var(--brand-primary)]',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
    }
    </>
  )
}
